// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Initial true-up status board (index route).
 *
 * Lists each cost currency and whether it is trued up, and links each
 * not-yet-trued currency to its per-currency initial true-up workflow at
 * /accounting/initial-true-up/<iso>.
 */
import { InitialTrueUpWorkflowPage } from '@/accounting/components/initial-true-up-workflow-page';
import { PageContent } from '@/components/page-content';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/accounting/initial-true-up/')({
  component: InitialTrueUpRoute,
});

function InitialTrueUpRoute() {
  return (
    <PageContent
      sx={{
        gap: 3,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <InitialTrueUpWorkflowPage />
    </PageContent>
  );
}
